function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Somos1DataEntryService from '@/apps/customer-insigths/services/somos1_data_entry_service';
import tasks from '@/js/tasks';
export default {
  name: 'TrackingDataentry',
  components: {},
  data: function data() {
    return {
      filter_enabled: false,
      years: null,
      selectedCell: null,
      selectedYear: null,
      headers: [{
        text: 'Organización',
        value: 'organization_name',
        align: 'start'
      }, {
        text: 'Ene',
        value: 'January'
      }, {
        text: 'Feb',
        value: 'February'
      }, {
        text: 'Mar',
        value: 'March'
      }, {
        text: 'Abr',
        value: 'April'
      }, {
        text: 'May',
        value: 'May'
      }, {
        text: 'Jun',
        value: 'June'
      }, {
        text: 'Jul',
        value: 'July'
      }, {
        text: 'Ago',
        value: 'August'
      }, {
        text: 'Sep',
        value: 'September'
      }, {
        text: 'Oct',
        value: 'October'
      }, {
        text: 'Nov',
        value: 'November'
      }, {
        text: 'Dic',
        value: 'December'
      }],
      organizations_dummy: [],
      keyDashboardsList: 0,
      valid: true,
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        }
      },
      org_indicators: [],
      selectedOrganization: null,
      selectedIdOrganization: null,
      selectedMonth: null,
      monthNamesToNumbers: {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      },
      months_en_es: {
        January: 'Enero',
        February: 'Febrero',
        March: 'Marzo',
        April: 'Abril',
        May: 'Mayo',
        June: 'Junio',
        July: 'Julio',
        August: 'Agosto',
        September: 'Septiembre',
        October: 'Octubre',
        November: 'Noviembre',
        December: 'Diciembre'
      }
    };
  },
  methods: {
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onLimpiar: function onLimpiar() {
      this.selectedYear = null;
      this.onSearch();
    },
    onSearch: function onSearch() {
      if (this.selectedYear) {
        this.post_tracking(this.selectedYear);
      }
    },
    post_tracking: function () {
      var _post_tracking = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(year) {
        var params, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              params = {
                year: year
              };
              _context.p = 1;
              _context.n = 2;
              return Somos1DataEntryService.postTracking(params);
            case 2:
              response = _context.v;
              if (response.success && response.code === 200) {
                this.organizations_dummy = response.data;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
              tasks.toast.error('error');
            case 4:
              _context.p = 4;
              this.keyDashboardsList += 1;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function post_tracking(_x) {
        return _post_tracking.apply(this, arguments);
      }
      return post_tracking;
    }(),
    post_tracking_org_year_month: function () {
      var _post_tracking_org_year_month = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              params = {
                year: this.selectedYear,
                month: this.convertMonthNameToNumber(this.selectedMonth),
                id_organization: this.selectedIdOrganization
              };
              _context2.p = 1;
              _context2.n = 2;
              return Somos1DataEntryService.postTrackingByOrgYearMonth(params);
            case 2:
              response = _context2.v;
              if (response.success && response.code === 200) {
                this.org_indicators = response.data;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error(_t2);
              tasks.toast.error('error');
            case 4:
              _context2.p = 4;
              this.keyDashboardsList += 1;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function post_tracking_org_year_month() {
        return _post_tracking_org_year_month.apply(this, arguments);
      }
      return post_tracking_org_year_month;
    }(),
    getCellClass: function getCellClass(item, month, value) {
      if (this.isEqualNAndM(value)) {
        if (this.selectedCell && this.selectedCell.item === item && this.selectedCell.key === month) {
          return ['pointer-on-hover', 'font-bold', 'completed'];
        } else {
          return ['pointer-on-hover', 'completed'];
        }
      } else {
        if (this.selectedCell && this.selectedCell.item === item && this.selectedCell.key === month) {
          return ['pointer-on-hover', 'font-bold', 'not-completed'];
        } else {
          return ['pointer-on-hover', 'not-completed'];
        }
      }
    },
    isEqualNAndM: function isEqualNAndM(value) {
      var parts = value.split('/');
      return parts[0] === parts[1];
    },
    onCellClick: function onCellClick(item, key) {
      this.selectedMonth = key;
      this.selectedOrganization = item.organization_name;
      this.selectedIdOrganization = item.id_organization;
      this.post_tracking_org_year_month();
      this.selectedCell = {
        item: item,
        key: key
      };
      console.log(this.selectedCell);
    },
    getLoadedIndicators: function getLoadedIndicators(data) {
      return data ? data.split('/')[0] : 0;
    },
    getTotalIndicators: function getTotalIndicators(data) {
      return data ? data.split('/')[1] : 0;
    },
    convertMonthNameToNumber: function convertMonthNameToNumber(monthName) {
      return this.monthNamesToNumbers[monthName];
    },
    convertMonthEnToEs: function convertMonthEnToEs(monthName) {
      return this.months_en_es[monthName];
    }
  },
  computed: {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    getMonthColumns: function getMonthColumns() {
      return this.headers.map(function (header) {
        return header.value;
      }).filter(function (header) {
        return header !== 'organization_name';
      });
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.customer.home'),
        disabled: false,
        href: '/#/customer_insights/home'
      }, {
        text: this.translate('menu.customer.somos1'),
        disabled: false,
        href: '/#/customer_insights/somos1_home'
      }, {
        text: this.translate('menu.customer.tracking_dataentry'),
        disabled: true,
        href: ''
      }];
    }
  },
  mounted: function mounted() {
    this.onSearch();
  },
  beforeMount: function beforeMount() {
    this.currentYear = new Date().getFullYear();
    this.years = [];
    for (var year = 2022; year <= this.currentYear; year++) {
      this.years.push({
        text: year.toString(),
        value: year.toString()
      });
    }
    this.selectedYear = this.currentYear.toString();
  }
};